module.exports = __webpack_public_path__ + "static/img/banner.b8b9c31.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/banner.jpg
// module id = swry
// module chunks = 1